// extracted by mini-css-extract-plugin
export default {"sozdat_text":"CreateProjectButton_sozdat_text__ByYNJ","create_button":"CreateProjectButton_create_button__0-5N6"};